import { render, staticRenderFns } from "./kehuPrice.vue?vue&type=template&id=cd32d016&scoped=true&"
import script from "./kehuPrice.vue?vue&type=script&lang=js&"
export * from "./kehuPrice.vue?vue&type=script&lang=js&"
import style0 from "./kehuPrice.vue?vue&type=style&index=0&id=cd32d016&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd32d016",
  null
  
)

export default component.exports